
<script>
import cartHotels from './hotels/Index.vue'
import Sidebar from './views/Sidebar.vue'
import TouristsForm from './views/TouristsForm.vue'
import cartInsurances from './insurances/Index.vue'
import cartCancelInsurance from './cancelInsurance/Index.vue'
import cartExcursions from './excursions/Index.vue'
import cartTransfers from './transfers/Index.vue'
import cartFlights from './flights/Index.vue'
import cartVisas from './visas/Index.vue'
import cartActualize from './actualize/Index.vue'

export default {
  name: 'cart',
  components: {
    cartHotels,
    Sidebar,
    TouristsForm,
    cartInsurances,
    cartCancelInsurance,
    cartExcursions,
    cartTransfers,
    cartFlights,
    cartVisas,
    cartActualize
  },
  metaInfo: {
    title: 'Корзина заказа'
  },
  computed: {
    mainService() {
      return this.$store.getters['cart/getMainService']
    },
    mainServiceAreLoaded() {
      return this.$store.getters['cart/mainServiceAreLoaded']
    }
  },
  watch: {
    'mainServiceAreLoaded'(val) {
      if (val) this.$store.dispatch('cart/getActualize')
    }
  },
  created() {
    const {
      params: { id, service },
      query
    } = this.$route

    this.$store.commit('cart/setMainService', service)

    this.$store.dispatch('cart/getCart', {
      id,
      service,
      query
    })

    this.$store.dispatch('getDictionary', {
      params: {},
      config: {
        dictionaryName: 'countries',
        target: 'cart.dictionaries.countries'
      }
    })
  },
  beforeDestroy() {
    this.$store.commit('cart/clearState')
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.commit('cart/changeBookingLoadingStatus', true)

          const {
            adults,
            children
          } = this.$store.getters['cart/getNumberOfTourists']

          this.$store.dispatch('cart/booking', {
            tourists: this.$store.getters['cart/getTouristsForSearch'],
            bookingInfo: {
              adults,
              children,
              meetingPlace: this.$store.getters['cart/getHotelInfo'].name,
              ...this.$store.getters['cart/getIds'].hotel,
              ...this.$store.getters['cart/getIds'].medicalInsurance,
              ...this.$store.getters['cart/getIds'].cancelInsurance,
              ...this.$store.getters['cart/getIds'].transfer,
              ...this.$store.getters['cart/getIds'].aviaticket,
              ...this.$store.getters['cart/getIds'].excursion,
              ...this.$store.getters['cart/getIds'].visa,
              ...this.$store.getters['cart/getTransfersFlightIds']
            }
          })
        } else {
          this.$buefy.snackbar.open({
            message: '<span>Ошибка валидации</span>Проверьте правильность заполнения формы туристов',
            type: 'is-danger',
            position: 'is-top-right',
            actionText: 'ОК',
            duration: 10000
          })
        }
      })
    }
  }
}
</script>

<template>
  <div class="cart">
    <div class="cart__header">
      <h1 class="cart__header--title">
        Корзина
      </h1>
    </div>
    <div class="cart__content app-container">
      <div class="cart__results app-page">
        <div class="cart__services">
          <cart-hotels />
          <cart-flights />
          <cart-transfers />
          <cart-visas
            v-if="mainService === 'hotels' || mainService === 'tours'"
          />
          <cart-insurances />
          <cart-cancel-insurance />
          <cart-excursions />
          <cart-actualize />
        </div>
        <tourists-form
          v-if="mainServiceAreLoaded"
        />
      </div>
      <sidebar />
    </div>
  </div>
</template>
